import { z } from 'zod';
import { displayId } from './common.js';
export const apInboxInputSchema = z.object({ ownershipId: displayId });
export const apInboxOutputSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('unavailable') }),
    z.object({ status: z.literal('none') }),
    z.object({ status: z.literal('active'), address: z.string().email() }),
]);
//# sourceMappingURL=apInbox.js.map